import React, { memo, useState } from "react";
import styles from "./HomeLayout.module.scss";
import { sideBarNavigation } from "utils/sideBarNavigation";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import mainIcon from "assets/svg/ffcorp_main.svg";
import zenputIcon from "assets/svg/logo_ffc.svg";
import { useDispatch, useSelector } from "react-redux";
import { checkRoutePermission, combineClasses } from "utils/utils";
import { clear, setNotification } from "redux/slices/homeSlice";
import { privateGet } from "services/privateRequest";
import { LOGOUT } from "services/apiEndpoints";
import LogoutIcon from "@mui/icons-material/Logout";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Notification from "components/pages/notification/Notification";

const LeftSideBar = ({ toggleSidebarOpen }) => {
  const { sidebarOpen } = useSelector((state) => state.home);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const clearOnLogout = async () => {
    await privateGet(LOGOUT);
    localStorage.clear();
    dispatch(clear());
    navigate("/login");
  };

  return (
    <>
      <div
        className={combineClasses(
          styles.leftSideContainer,
          !sidebarOpen ? styles.sidebarClosed : styles.sidebarOpen
        )}
        onMouseOver={toggleSidebarOpen(true)}
      >
        <div className={styles.logoContainer}>
          <div className={styles.iconContainer}>
            <div className={styles.mainIconDiv}>
              <img
                src={sidebarOpen ? mainIcon : zenputIcon}
                alt="FFCorp Survey App icon"
                className={
                  sidebarOpen ? styles.mainIconImage : styles.mainZenputIcon
                }
              />
            </div>
            {/* {sidebarOpen && <p>CREDIT.CARD</p>} */}
          </div>
        </div>
        <div className={styles.navContainer}>
          {sideBarNavigation
            .filter((data) => {
              return checkRoutePermission(data.permissionName);
            })
            .map((data) => {
              const { icon: Icon } = data;
              return (
                <div key={data.id}>
                  {
                    //this condition is for notification
                    data?.button ?
                      <div
                        className={`${styles.navLink} ${!sidebarOpen ? styles.sidebarClosed : ""} `}
                        onClick={(e) => {
                          dispatch(setNotification(true))
                        }}
                      // state={{ previousPath: location.pathname }}
                      >
                        <div className={styles.linksNames}>
                          <Icon className={styles.icon} />
                          {sidebarOpen && (
                            <>
                              <p className={styles.linkPageName}>{data.pageName}</p>
                            </>
                          )}
                        </div>
                      </div>
                      :
                      <NavLink
                        className={({ isActive }) =>
                          `${styles.navLink} ${!sidebarOpen ? styles.sidebarClosed : ""
                          } ${isActive && styles.activeLink}`
                        }
                        to={data.path}
                        state={{ previousPath: location.pathname }}
                      >
                        <div className={styles.linksNames}>
                          <Icon className={styles.icon} />
                          {sidebarOpen && (
                            <>
                              <p className={styles.linkPageName}>{data.pageName}</p>
                            </>
                          )}
                        </div>
                      </NavLink>
                  }

                  {sidebarOpen &&
                    location.pathname.includes(data.path) &&
                    data?.children &&
                    data?.children?.map((child_route) => (
                      <NavLink
                        className={({ isActive }) =>
                          `${styles.childNavLink} ${isActive && styles.childactiveLink
                          }`
                        }
                        to={child_route.path}
                        state={{ previousPath: location.pathname }}
                      >
                        <div className={styles.childlinksNames}>
                          <FiberManualRecordIcon />
                          <p className={styles.childlinkPageName}>
                            {child_route.pageName}
                          </p>
                        </div>
                      </NavLink>
                    ))}
                </div>
              );
            })}
        </div>
        <div
          className={`${styles.navLink} ${styles.logoutButton} ${!sidebarOpen ? styles.sidebarClosed : ""
            }`}
          onClick={clearOnLogout}
        >
          <div className={styles.linksNames}>
            <LogoutIcon />
            {sidebarOpen && <p className={styles.linkPageName}>Logout</p>}
          </div>
        </div>
      </div>
      {/* ///notification modal */}
      <Notification />
    </>
  );

};

export default memo(LeftSideBar);
